import { SearchtoolboxService } from './../../_services/searchtoolbox.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TransactionService } from 'src/app/_services/transaction.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  @ViewChild('planupgrade') planupgrade: TemplateRef<any>;
  subscriptiondetails: any;
  monthlyplans: any;
  annualplans: any;
  paymentPage: boolean = true
  paymentForm: FormGroup;
  planselected: any = 'monthly';
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  paymentFormDetails: any;
  allplans: any;
  selectedplan: any;
  countryList: any[] = [];
  cityList: any[] = [];
  stateList: any[] = [];
  countryid: any;
  stateid: any;
  paidplans: any;
  finalCost: any;
  isIndiaSelected: boolean;
  countryisocode: any;
  stripecustomerid: any;
  paymentplanid: any;
  successMessage: string;
  errorMessage: string;
  activeplan: any;
  constructor(private modalService: NgbModal, private _localstorage: LocalStorageService, private transactionservice: TransactionService, private fb: FormBuilder,
    private router: Router, private route: ActivatedRoute, private searchservice: SearchtoolboxService) { }

  ngOnInit() {
    this.getCurrentplanDetails()
    let fname = this._localstorage.getItem('ufname') + ' ' + this._localstorage.getItem('ulname')
    this.paymentForm = this.fb.group({
      fname: [fname, Validators.compose([Validators.required])],
      emailid: [{ value: this._localstorage.getItem('usermailid') , disabled: true }, Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')])],
      phone: ['', Validators.compose([Validators.required])],
      country: ['', Validators.compose([Validators.required])]
    })
  }

  getCurrentplanDetails() {
    this.activeplan = {
      paymentplanname : this._localstorage.getItem('paymentplanname'),
      plantype : this._localstorage.getItem('plantype'),
    }
    this.transactionservice.fetchallstripeplans().subscribe((res: any) => {
      this.allplans = res.data
      let paymentplanid = this.route.snapshot.queryParamMap.get('paymentplanid')
      if(paymentplanid){
        this.transactionservice.fetchplan(paymentplanid).subscribe((res:any)=>{
          if(res.status == 'success' && res.data.length){
            this.chooseplan(res.data[0].paymentplanname, res.data[0].plantype)
          }
        })
      }
    })
  }

  chooseplan(paymentplanname, plantype) {
    this.planselected = plantype
    if (paymentplanname == 'sales') {
      let data = {
        "emailid": this._localstorage.getItem('usermailid'),
        "requesttype": "upgrade",
        "paymentplanid": null,
        "paymentplanname": null,
        "plantype": 'custom',
        "plancost": null,
        "requestedplandetails": 'Custom Plan',
        "ongoingplandetails" : this._localstorage.getItem('paymentplanname') ? this._localstorage.getItem('paymentplanname') : 'Free'
      }
      this.transactionservice.chaneplan(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.modalService.open(this.planupgrade, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
          this.getCurrentplanDetails()
        }
      })
    }else{
      this.selectedplan = this.allplans.filter(x => x.paymentplanname == paymentplanname && x.plantype == plantype)[0]
      this.paymentplanid = this.selectedplan.paymentplanid
      this.paymentPage = false
      if (this._localstorage.getItem('stripecustomerid') && this._localstorage.getItem('stripebillingcountry')) {
        let checkoutDAta = {
          "paymentplanid": this.paymentplanid,
          "stripecustomerid": this._localstorage.getItem('stripecustomerid'),
          "isindian": this._localstorage.getItem('stripebillingcountry') == 'IN' ? true : false,
        }
        this.createCheckoutURL(checkoutDAta)
      }
    }
  }

  route2paymentForm() {
    this.paymentFormDetails = this.paymentForm.getRawValue()
    if (this.paymentForm.valid) {
      let createCustomerData = {
        "email": this.paymentFormDetails.emailid,
        "country" : this.countryisocode
      }
      this.transactionservice.createcustomer(createCustomerData).subscribe((res: any) => {
        if (res.status == 'success') {
          this.stripecustomerid = res.stripecustomerid
          this._localstorage.setItem('stripecustomerid',this.stripecustomerid)
          this._localstorage.setItem('stripebillingcountry',this.countryisocode)
          let checkoutDAta = {
            "paymentplanid": this.paymentplanid,
            "stripecustomerid": this.stripecustomerid,
            "isindian": this.countryisocode == 'IN' ? true : false,
          }
          this.createCheckoutURL(checkoutDAta)
        }
      })

    } else {
      this.validateAllFormFields(this.paymentForm)
    }
    let el = document.getElementById('scrollhere');
    el.scrollIntoView();
  }

  createCheckoutURL(data) {
    this.transactionservice.createcheckouturl(data).subscribe((res: any) => {
        window.open(res.checkouturl, "_self");
    })
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  getTypeahead(type, e) {
    if (e.target.value && e.target.value.trim == '') {
      this.stateid = null
      this.countryid = null
    }
    let data = {
      "dropdowntype": type,
      "searchedstring": e.target.value
    }
    if (type == 'states' && this.countryid) {
      data['countryid'] = this.countryid
    }
    if (type == 'cities' && this.stateid) {
      data['stateid'] = this.stateid
    }
    this.searchservice.getAutoCompleteDataList(data).subscribe((res: any) => {
      if (type == 'countries') {
        this.countryList = res.data
      } else if (type == 'states') {
        this.stateList = res.data
      } else if (type == 'cities') {
        this.cityList = res.data
      }
    })
  }

  selectTypeahead(value, type) {
    if (type == 'country') {
      this.countryid = value.countryid
      this.countryisocode = value.isocode
      this.paymentForm.patchValue({
        country: value.countryname
      })
    }
  }

  returnDividedCost(value, type) {
    if (type) {
      return (parseInt(value) / 10) * 12
    } else {
      return parseInt(value) / 10
    }
  }
}
